import { useState, useLayoutEffect } from 'react';

function detectWebGL(): boolean {
  try {
    const canvas = document.createElement('canvas');
    return !!(
      canvas.getContext('webgl2') || canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    );
  } catch {
    return false;
  }
}

/**
 * Encapsulates client-side mounting logic needed before rendering a Three.js
 * Canvas. The `isMounted` flag prevents SSR from attempting to render WebGL.
 * The `hasWebGL` flag allows consumers to show a fallback when WebGL is
 * unavailable (e.g. low-GPU mobile devices).
 */
export function useThreeScene() {
  const [isMounted, setIsMounted] = useState(false);
  const [hasWebGL, setHasWebGL] = useState(true);

  useLayoutEffect(() => {
    setHasWebGL(detectWebGL());
    setIsMounted(true);
  }, []);

  return { isMounted, hasWebGL };
}
